// Stripe error codes for analytics. Enum values only — never the resolved
// message, which can carry raw API text.
//
// Same shape handling as getStripeErrorMessage's payload lookup: stripe.js
// rejects with the error itself, the API nests it under the response body.
const stripeErrorFields = (error) => {
  const body = error?.response?.data ?? error?.response ?? error?.body
  const source =
    body?.decline_code == null && body?.code == null ? error : body

  return {
    code: source?.code ?? undefined,
    decline_code: source?.decline_code ?? undefined,
    type: source?.type ?? undefined,
  }
}

export default stripeErrorFields
